import { LoadablePaint } from '@confluence/loadable';

export const ShareableLinkSpaceAdminConfigurationLoader = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ShareableLinkSpaceConfiguration" */ './components/SpaceConfigPage.tsx'
			)
		).SpaceConfigPage,
});
